export default __webpack_public_path__ + "static/media/2day-intensiveTraining-shaded.68f8b5ef.png";